// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable class-methods-use-this */
import * as React from "react"

import { modals } from "../../../../utils/nitroSideEffects"

type Props = {
  modal: string
}

export default class Core extends React.PureComponent<Props> {
  componentDidUpdate() {
    const { modal } = this.props

    // @ts-expect-error: Flow to TS migration.
    modals(modal)
  }

  render() {
    return null
  }
}
